import { render } from "./RejectReasonModal.vue?vue&type=template&id=61b218b0&scoped=true"
import script from "./RejectReasonModal.vue?vue&type=script&lang=js"
export * from "./RejectReasonModal.vue?vue&type=script&lang=js"

import "./RejectReasonModal.vue?vue&type=style&index=0&id=61b218b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61b218b0"]])

export default __exports__